import { useTranslation } from 'react-i18next'

import type { ReturnLogsReadable } from '@crm/api'

type Props = {
  log: ReturnLogsReadable
}

export const useGetTranslatedDescription = ({ log }: Props) => {
  const {
    i18n: { language }
  } = useTranslation()

  const translatedDescription = `description_${
    language ?? 'en'
  }` as keyof ReturnLogsReadable

  return String(log?.[translatedDescription])
}
